<template>
  <p class="danger">{{ message }}</p>
</template>

<script>
export default {
  props: {
    message: String,
  },
}
</script>
